// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"3de5f703","531":"9c6f7f5e"}[chunkId] + ".chunk.js";
};